import { List } from 'immutable';
import { put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import * as EntityUtils from '../../../lib/EntityUtils';
import Logger from '../../../tools/Logger';

const log = Logger.child({
  component: 'mediator/garbageCollect',
});

const DEFAULT_MAX_ENTITIES_SIZE = 1000;
// Amount we'll invalidate when we reach max
const TRIM_PERCENT = 30;

export function* garbageCollect() {
  const entitiesToGC = yield select(EntityUtils.getAllAnnotations);
  log.info(`garbageCollect(): check entities size -> ${entitiesToGC.size}`);

  if (entitiesToGC && entitiesToGC.size > DEFAULT_MAX_ENTITIES_SIZE) {
    log.info(
      `garbageCollect(): garbage collecting entities -> ${entitiesToGC.size} > ${DEFAULT_MAX_ENTITIES_SIZE}`,
    );

    const collectionItems = yield select(
      getInDomain('collection.utils.getCollectionItems', List()),
    );
    const collectedIds = collectionItems.map(item => item.pandoraId);
    const recentlyPlayedItems = yield select(
      getInDomain('collection.utils.getRecentlyPlayedSPSItems', List()),
    );
    const recentlyPlayedIds = recentlyPlayedItems.map(item => item.id);

    const currentlyPlayingId = yield select(getInDomain('playback.utils.getCurrentPlaylist', null));
    const currentlyPlayingSourceType = yield select(
      getInDomain('playback.utils.getCurrentPlaylistType', null),
    );
    const nowPlayingTrackIds = yield select(
      getInDomain('catalog.utils.getTrackGetterBySourceType')(currentlyPlayingSourceType),
      currentlyPlayingId,
    );

    const idsToRetain = collectedIds.concat(recentlyPlayedIds, nowPlayingTrackIds, [
      currentlyPlayingId,
    ]);
    const retainedAnnotationsList = idsToRetain
      .map(id => {
        return entitiesToGC.get(id);
      })
      .filter(annotation => !!annotation);
    const retainedAnnotations = new Map(
      retainedAnnotationsList.map(annotation => {
        return [annotation.get('pandoraId'), annotation];
      }),
    );

    const endSlice = Math.round(DEFAULT_MAX_ENTITIES_SIZE * ((100 - TRIM_PERCENT) / 100));
    const updatedAnnotations = entitiesToGC.slice(-endSlice).concat(retainedAnnotations);

    yield put(Actions.Annotations.overwriteAnnotations(updatedAnnotations));
  }
}
